import { FileStatus } from '../enums/file-status.enum';
import { ScanStatus } from '../enums/scan-status.enum';

export class AttachDocument {
    name?: string;
    internalFileName?: string;
    icon?: string;
    status?: ScanStatus;
    fileStatus: FileStatus;
}
